import { css, styled } from 'styled-components'

export const Hint = styled.div`
  align-items: center;
  background: rgba(0, 0, 0, 0.45);
  border-radius: inherit;
  color: #fff;
  display: flex;
  inset: 0;
  justify-content: center;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  transition: opacity 0.15s ease;

  :hover > &,
  :focus-visible > & {
    opacity: 1;
  }

  && svg {
    aspect-ratio: 1 / 1;
    color: #fff;
    height: var(--zoom-hint-size, 3.2rem);
    width: var(--zoom-hint-size, 3.2rem);
  }
`

export const Container = styled.div`
  border-radius: ${({ theme }) => theme.border.radius[12]};
  cursor: zoom-in;
  flex-shrink: 0;
  overflow: hidden;
  position: relative;
`

const fillStyles = css`
  display: block;
  height: 100%;
  width: 100%;
`

export const Frame = styled.span<{ readonly $fill: boolean }>`
  border-radius: inherit;
  cursor: zoom-in;
  display: inline-block;
  line-height: 0;
  max-width: 100%;
  overflow: hidden;
  position: relative;
  vertical-align: top;

  ${({ $fill }) => $fill && fillStyles}

  img {
    max-width: 100%;
  }
`

export const Image = styled.img<{ readonly $fit: 'contain' | 'cover' }>`
  display: block;
  height: 100%;
  object-fit: ${({ $fit }) => $fit};
  width: 100%;
`
